<template>
  <div class="content">
    <div class="card-wrap" v-for="(item , index) in list" :key="index">
      <!-- nouse 这个优惠券不能使用了 -->
      <coupon-card nouse="1" :data="item" type="2"></coupon-card>
    </div>
    <div class="no-coupon" v-if="nodata">
      <img src="@/common/image/no-coupon.png" alt="">
      <p>您还没有优惠券</p>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Scroll from 'components/base/scroll/scroll'
import CouponCard from './coupon-card'
import {getUserCoupon} from '@/api/user-center.js'
import {RES_OK} from '@/api/config'
export default {
  data() {
    return {
      list: [],
      nodata: false
    }
  },
  components: {
    Scroll,
    CouponCard
  },
  created() {
    // 2 已使用
    getUserCoupon(2).then((res) => {
      let data = res.data
      if (data && data.code === RES_OK && data.data) {
        this.list = data.data.list
        if (this.list.length === 0) {
          this.nodata = true
        }
        this.$emit('data', data.data.nums)
      }
    })
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .content
    padding size(90 + 40 + 30 + 102) size(40) size(30)
  .card-wrap
    margin-bottom size(30)
  .no-coupon
    width size(300)
    margin size(210) auto
    p
      color #999
      text-align center
      font-size size(30)
      margin-top size(58)
    img
      display block
      width 100%
</style>



// WEBPACK FOOTER //
// src/components/personal/coupon/coupon-used.vue